import { render, staticRenderFns } from "./Checkdetail.vue?vue&type=template&id=bdf9508a&scoped=true&"
import script from "./Checkdetail.vue?vue&type=script&lang=js&"
export * from "./Checkdetail.vue?vue&type=script&lang=js&"
import style0 from "./Checkdetail.vue?vue&type=style&index=0&id=bdf9508a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdf9508a",
  null
  
)

export default component.exports